<div class="modal fade" id="paymentDialog" data-keyboard="false" 
    data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="payment-loader" *ngIf="loadingPayment">
          <div class="cssload-speeding-wheel"></div>
        </div>
        <iframe sandbox="allow-scripts allow-forms allow-modals allow-popups allow-same-origin" #paymentIframe class="payment-iframe"></iframe>
      </div>
    </div>
  </div>
</div>